import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import { strings } from '@constants'
import Switch from '../Switch'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import ProgressBar from '../ProgressBar'
import { Text } from '@styles'
import { getInputType } from '@base/composite/Table/TableUtils/Columns'
import { showDateFormat } from '@utils'
import { paths } from '@routes'

const ProgressBarWapper = styled.div`
	width: 100%;
`

const OpenPurchaseOrders = ({ open_purchase_order_delayed, open_purchase_order_running, open_purchase_count, running, delayed }) => {
	const [status, setStatus] = useState('DELAY')

	const columns = useMemo(
		() => [
			{
				label: strings(['buyer', '/', 'order_id']),
				key: (data) => data,
				renderer: (data) => {
					return (
						<>
							<div>
								<b>{data?.buyer_name ?? '--'}</b>
							</div>
							<div>
								<small>{data?.order_id ?? '--'}</small>
							</div>
						</>
					)
				},
				mobile: true,
			},

			{
				label: strings('po', 'number'),
				key: 'po_number',
				mobile: true,
			},
			{
				label: strings('delivery', 'city'),
				key: 'delivery_city',
				align: 'left',
				mobile: false,
			},
			{
				label: strings('sales', 'person'),
				key: 'sales_person',
				mobile: true,
			},
			{
				label: `${strings('po')} ${strings('completion_date')} / ${strings('order_date')}`,
				key: (itemData) => {
					return (
						<>
							<div>
								<b>{itemData?.po_completion_date ? showDateFormat(new Date(itemData?.po_completion_date)) : '-'}</b>
							</div>
							<div>
								<small>{itemData?.order_date ? showDateFormat(new Date(itemData?.order_date)) : '-'}</small>
							</div>
						</>
					)
				},
			},

			{
				label: `${strings('serviced')} vs ${strings('ordered')}`,
				key: (itemData) => {
					const servedPercent = Math.round((itemData?.serviced_weight / itemData?.ordered_weight) * 100)
					return (
						<ProgressBarWapper>
							<span>
								{itemData?.serviced_weight} / {itemData?.ordered_weight} {getInputType(itemData?.input_type)}
							</span>
							<ProgressBar fillColor={servedPercent} value={servedPercent} fontSize={Text.EXTRA_SMALL} />
						</ProgressBarWapper>
					)
				},
				mobile: false,
				cellWidth: 25,
			},
		],

		[]
	)

	const rowClickHandler = (row) => {
		window.open(paths.admin_manage_enquiry_order_edit(row?.order_id), '_blank')
	}

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Open Purchase Orders({open_purchase_count})</Heading>
				<Switch
					options={[
						{ label: `Running(${running})`, value: 'RUN' },
						{ label: `Delayed(${delayed})`, value: 'DELAY' },
					]}
					value={status}
					onChange={setStatus}
				/>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight
					data={status === 'RUN' ? open_purchase_order_running : open_purchase_order_delayed}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					hideFooter
					rowClickable={true}
					onRowClick={rowClickHandler}
				/>
			</TableContainer>
		</Wapper>
	)
}

export default OpenPurchaseOrders
